const initialDotParams = {
  // Visuals
  background: 'rgb(1,65,57)',
  spacing: 48,
  fill: 0.45,

  // Dot logic (global noise)
  noiseScale: 0.35,
  noiseAmp: 0.45,
  noiseSpeed: 0.12,
  threshold: 0.55,

  // Mouse influence (per-dot)
  mouseRadius: 180, // base radius (px)
  mouseFalloff: 120,
  mouseAmp: 1.0,

  // Mouse “cloud” irregularity (extra noise on the mouse area)
  mouseNoiseScale: 0.3,
  mouseNoiseAmp: 0.65, // 0..1 (0.35 = nice “edgy cloud”)
  mouseNoiseSpeed: 0.25,

  // Velocity → dynamic radius boost
  radiusBoost: 0, // current extra radius (px), animated
  velocityScale: 0.18, // px of boost per (px/s)
  velocityMaxBoost: 80, // clamp boost
  boostResponse: 0.15, // tween duration toward new boost
  leaveShrinkDuration: 0.35, // tween duration to shrink on leave

  // GSAP follow
  followDuration: 0.25,
  followEase: 'power3.out' as gsap.EaseString,

  // Gyro controls
  gyroEnabled: true,
  gyroStrength: 0.8, // how far tilt moves the mask
  gyroDeadzoneDeg: 3, // ignore tiny jitters
  gyroMaxTiltDeg: 30, // clamp usable tilt
  gyroEaseDuration: 0.8, // GSAP duration to move smoothMouse

  // Logic
  invert: true,

  // Fill “wave” (per-dot radius growth from mouse)
  fillRevealTarget: 0.45, // target fill when revealed
  fillWaveR: 0, // current wave radius in px (animated)
  fillWaveWidth: 0, // band softness (px) for the front; use 0 for hard front
};

// Add your favorite params here, they will show up in the GUI presets dropdown
export const paramProposals = [
  {
    name: 'Fluidyy',
    params: {
      background: 'rgb(1,65,57)',
      spacing: 48,
      fill: 0.41,
      noiseScale: 0.25,
      noiseAmp: 0.36,
      noiseSpeed: 0.22,
      threshold: 0.63,
      mouseRadius: 255,
      mouseFalloff: 34,
      mouseAmp: 0.72,
      mouseNoiseScale: 0.27,
      mouseNoiseAmp: 0.63,
      mouseNoiseSpeed: 0.3,
      radiusBoost: 197,
      velocityScale: 0.23,
      velocityMaxBoost: 197,
      boostResponse: 0.44,
      leaveShrinkDuration: 0.35,
      followDuration: 0.55,
      followEase: 'power3.out',
      gyroEnabled: true,
      gyroStrength: 0.8,
      gyroDeadzoneDeg: 3,
      gyroMaxTiltDeg: 30,
      gyroEaseDuration: 0.8,
      invert: true,

      // Fill “wave” (per-dot radius growth from mouse)
      fillRevealTarget: 0.45, // target fill when revealed
      fillWaveR: 0, // current wave radius in px (animated)
      fillWaveWidth: 0, // band softness (px) for the front; use 0 for hard front
    },
  },
  { name: 'First try', params: initialDotParams },
  {
    name: 'smoothier?',
    params: {
      background: 'rgb(1,65,57)',
      spacing: 49,
      fill: 0.37,
      noiseScale: 0.25,
      noiseAmp: 0.36,
      noiseSpeed: 0.22,
      threshold: 0.500936,
      mouseRadius: 122,
      mouseFalloff: 300,
      mouseAmp: 1.44,
      mouseNoiseScale: 0.27,
      mouseNoiseAmp: 0.63,
      mouseNoiseSpeed: 0.3,
      radiusBoost: 1.033504,
      velocityScale: 0.05,
      velocityMaxBoost: 329,
      boostResponse: 0.56,
      leaveShrinkDuration: 0.09,
      followDuration: 1.2,
      followEase: 'expo.out',
      gyroEnabled: true,
      gyroStrength: 0.8,
      gyroDeadzoneDeg: 3,
      gyroMaxTiltDeg: 30,
      gyroEaseDuration: 0.8,
      invert: true,
      fillRevealTarget: 0.45,
      fillWaveR: 0,
      fillWaveWidth: 0,
    },
  },
];
